import { DeckInfo } from "./types";

export const allDecks: DeckInfo[] = [
  {
    author: "Benana",
    title: "2024 Constructed Tournament - 1st - UB Meth Control",
    text: "",
    cards: {
      main: [
        { count: 2, name: "Ashnod's Waltar" },
        { count: 3, name: "Sheoldred, Whispering One (hc)" },
        { count: 1, name: "Thinking About Volleyballs" },
        { count: 4, name: "Flummox" },
        { count: 3, name: "Inside Job" },
        { count: 3, name: "Taking it Personally" },
        { count: 4, name: "Inquisition of Haktos the Unscarred" },
        { count: 2, name: "Mana Auction" },
        { count: 1, name: "Where joke" },
        { count: 2, name: "Paul Blartist" },
        { count: 2, name: "Snapcorpser Mage" },
        {
          count: 3,
          name: "Opting to be Pre-Pondering for Visions of Thoughts",
        },
        { count: 4, name: "Opt // Opt 2" },
        { count: 3, name: "Swiss Army Mänufactör" },
        { count: 4, name: "Permeating Pass" },
        { count: 3, name: "Evolving Fabled Terramorphic Vista" },
        { count: 4, name: "Polluted Δ" },
        { count: 5, name: "Island" },
        { count: 3, name: "Swamp" },
        { count: 2, name: "Half-Thriving ____ Half-Thriving ____" },
        { count: 2, name: "The Prismatic Piper (hc)" },
      ],
      sideboard: [
        { count: 2, name: "Snapcorpser Mage" },
        { count: 2, name: "TL;DR (hc3)" },
        { count: 3, name: "Where joke" },
        {
          count: 4,
          name: "Hellscube users make a good card design challenge (impossible)",
        },
        { count: 4, name: "Your Cards Aren't Very Funny" },
      ],
    },
  },
  {
    author: "Requiem",
    title: "2024 Constructed Tournament - 2nd - RDW",
    text: "",
    cards: {
      main: [
        { count: 4, name: "Eldrazi Goblin Guide" },
        { count: 4, name: "Spork Elemental" },
        { count: 4, name: "Gobbling Guide" },
        { count: 3, name: "Gut, True Shot Zealot" },
        { count: 4, name: "Cathartic Cathar" },
        { count: 4, name: "We Gonna Rock Down // Electric Avenue" },
        { count: 4, name: "Lightning Bolt with Extra Steps" },
        { count: 13, name: "Mountain" },
        { count: 4, name: "Krark-Clan Ironworkers Union" },
        { count: 2, name: "Warehouse // Werehouse" },
        { count: 4, name: "Kobolt, Excited Sparkmage" },
        { count: 4, name: "A Stomp To The Balls" },
        { count: 4, name: "Lavahearth Burst" },
      ],
      sideboard: [
        { count: 3, name: "It That Bears Gifts" },
        { count: 1, name: "Agent Fblthp" },
        { count: 1, name: "Siege Rhino EX" },
        { count: 2, name: "The Prismatic Piper (hc)" },
        { count: 3, name: "Geistshot" },
        { count: 4, name: "Krenko's Remand" },
        { count: 3, name: "Permeating Pass" },
      ],
    },
  },
  {
    author: "Nobroam",
    title: "2024 Constructed Tournament - Top 4 - Errata Control",
    text: "",
    cards: {
      sideboard: [
        { count: 4, name: "Tax Evasion" },
        { count: 2, name: "Unflips Your Delver" },
        { count: 2, name: "Mana Auction" },
        { count: 1, name: "Trade With Timmy" },
        { count: 1, name: "Bog" },
        { count: 1, name: "Swamp" },
        { count: 2, name: "Minions: The Rise of Gru" },
        { count: 2, name: "Cultural Revolution" },
      ],
      main: [
        { count: 4, name: "Errata, the Silencer" },
        { count: 4, name: "Sheoldred, Whispering One (hc)" },
        { count: 4, name: "Memory Lapse (Not the Homelands One)" },
        { count: 2, name: "Unflips Your Delver" },
        { count: 4, name: "See if I Care" },
        { count: 4, name: "Opt Twice" },
        { count: 3, name: "Dracjack" },
        { count: 2, name: "Trade With Timmy" },
        { count: 4, name: "Flummox" },
        { count: 2, name: "Bog" },
        { count: 3, name: "Watergate (hc6)" },

        { count: 1, name: "Karzilek, Butcher of Pavement" },
        { count: 4, name: "Half-Thriving ____ Half-Thriving ____" },
        { count: 4, name: "Actual Cascade Bluffs" },
        { count: 4, name: "Coastal Bluffs" },
        { count: 4, name: "Polluted Δ" },
        { count: 1, name: "Wasteland Oasis" },
        { count: 1, name: "Indatha Land Kathril Approves Of" },
        { count: 1, name: "Island GX" },
        { count: 4, name: "Inquisition of Haktos the Unscarred" },
      ],
    },
  },
  {
    author: "Frognarch",
    title: "2024 Constructed Tournament - Top 4 - WB Limitless Lasagna",
    text: `Garfield, you fat cat. Why are you so big and fat?
Swiss Army Mänufactör and a Sac outlet that makes tokens is a notably strong and easily enableable combo in hellscube constructed, the two cards combine for infinite death triggers, infinite artifact leaving the battlefield triggers, and when combined with something like Paul Blartist, Mall Cop, wins the game outright. This combo can be easy to get to, pieces can be as easy to find as the land Harare, or can be tutored for with reliability like Make-A-Wish.
This deck benefits from the card Garfield Mystic reducing the price of premier removal spells like Yeast Within and Wizard Spell to allow for cheap and quick responses. It also reduces the price of the Mänufactör, Kambar, and other token payoffs, making the endgame come much faster, and combos for an infinitely large creature with the final combo if a Paul Blartist cannot be easily found.
If the combo just does not show up, tempo cards with incredibly strong results like Batterie Antoinette come out cheap and quick, and Tolkien, Toking allows for a board with any amount of tokens  to quickly become game winning (Notably making a bunch of 4/3 sharks with Biterblossom)
The reason the deck runs no copies of Prismatic Piper, instead of taking advantage of the free -2 deck size is that I am making a genius meta-play against the dominant mill meta deck. It is not because I did not know about and had never seen Piper before today.`,
    cards: {
      main: [
        { count: 4, name: "Zoning Violation" },
        { count: 4, name: "Biterblossom" },
        { count: 3, name: "Evil Fucking Wizard Spell" },
        { count: 3, name: "Army in a Can" },
        { count: 2, name: "Yeast Within" },
        { count: 3, name: "Make-a-Wish" },
        { count: 4, name: "Garfield Mystic" },
        { count: 3, name: "Tolkien, Toking" },
        { count: 3, name: "Kamber, Soda Enthusiast" },
        { count: 3, name: "Swiss Army Mänufactör" },
        { count: 3, name: "Batterie Antoinette" },
        { count: 4, name: "Harare" },
        { count: 2, name: "Indatha Land Kathril Approves Of" },
        { count: 2, name: "Marsh Flats (Hellscube)" },
        { count: 9, name: "Plains" },
        { count: 10, name: "Swamp" },
      ],
      sideboard: [
        { count: 3, name: "Wilski's Whimper" },
        { count: 3, name: "Yeast Within" },
        { count: 2, name: "Tormod's MTV Crypts" },
        { count: 1, name: "Thalia, Guardian Against Bullshit" },
        { count: 2, name: "Paul Blartist" },
        { count: 1, name: "Kamber, Soda Enthusiast" },
        { count: 2, name: "Myr in Misery" },
        { count: 1, name: "Swiss Army Mänufactör" },
      ],
    },
  },
  {
    author: "Glassbass",
    title: "2024 Constructed Tournament - Top 8 - Pyramid Tempo",
    text: "",
    cards: {
      sideboard: [
        { count: 2, name: "Tormod's MTV Crypts" },
        { count: 3, name: "Harsh Judge" },
        { count: 2, name: "For bid" },
        { count: 4, name: "Pay You 100 To Fuck Off" },
        { count: 4, name: "Divine Gambit but It's Fucking Stupid" },
      ],
      main: [
        { count: 3, name: "Pyramid Schemer" },
        { count: 4, name: "Sheoldred, Whispering One (hc)" },
        { count: 3, name: "Knight of the Whiter Orchid" },
        { count: 4, name: "White Counterspell" },
        { count: 4, name: "Inside Job" },
        { count: 3, name: "Figure of Removal" },
        { count: 4, name: "Card Leak" },
        { count: 2, name: "For bid" },
        { count: 3, name: "Swamp" },
        { count: 6, name: "Plains" },
        { count: 4, name: "Hidden Temple of Legends" },
        { count: 4, name: "Half-Thriving ____ Half-Thriving ____" },
        { count: 2, name: "The Dream Den" },
        { count: 4, name: "Indatha Land Kathril Approves Of" },
        { count: 4, name: "Inquisition of Haktos the Unscarred" },
        { count: 4, name: "Dis Enchant" },
        { count: 2, name: "The Prismatic Piper (hc)" },
      ],
    },
  },
  {
    author: "KillerE",
    title: "2024 Constructed Tournament - Top 8 - Shark Cheese",
    text: "",
    cards: {
      sideboard: [
        { count: 1, name: "Sixty-four slices of American Cheese" },
        { count: 4, name: "Force Pike" },
        { count: 3, name: "Mana Auction" },
        { count: 3, name: "Crucifact or Crucifixion" },
        { count: 2, name: "Thirst for Thirst" },
      ],
      main: [
        { count: 2, name: "The Prismatic Piper (hc)" },
        { count: 4, name: "Shark Ritual" },
        { count: 3, name: "Spooky Scary Spectre" },
        { count: 3, name: "Agent Fblthp" },
        { count: 2, name: "Eye in the Sky" },
        { count: 3, name: "Blue Arm of the Forbidden One" },
        { count: 4, name: "CMD-Elemental" },
        { count: 4, name: "Genetic Reshuffle" },
        { count: 4, name: "TL;DR (hc3)" },
        { count: 4, name: "Flummox" },
        {
          count: 4,
          name: "Opting to be Pre-Pondering for Visions of Thoughts",
        },
        { count: 3, name: "Phyrexian Mana Confluence" },
        { count: 4, name: "Shifting River // Shifting Forest" },
        { count: 4, name: "Swamp (hc)" },
        { count: 6, name: "Island" },
        { count: 2, name: "Forest" },
        { count: 4, name: "Evolving Fabled Terramorphic Vista" },
      ],
    },
  },
  {
    author: "Target Idiot Mono Red Player",
    title: "2024 Constructed Tournament - Top 8 - White Token Midrange",
    text: "",
    cards: {
      sideboard: [
        { count: 3, name: "Ashnod's Waltar" },
        { count: 3, name: "Discount Mox Box" },
        { count: 2, name: "Tormod's MTV Crypts" },
        { count: 1, name: "Totally Just a Cantrip I Swear" },
        { count: 3, name: "Swiss Army Mänufactör" },
        { count: 3, name: "1/2 of Elesh Norn, Rounded Up" },
      ],
      main: [
        { count: 2, name: "My Most Favoritest Goat" },
        { count: 4, name: "Thallid but they go to Church now" },
        { count: 2, name: "Restoration Twin" },
        { count: 4, name: "Knight of the Whiter Orchid" },
        { count: 3, name: "Arid Mesa Enchantress" },
        { count: 3, name: "Ajani's Pride Mate" },
        { count: 4, name: "Curse of Unpaid Internship" },
        { count: 2, name: "White Counterspell" },
        { count: 1, name: "Opposite Day" },
        { count: 2, name: "Divine Gambit but It's Fucking Stupid" },
        { count: 4, name: "Pay You 100 To Fuck Off" },
        { count: 3, name: "Card Leak" },
        { count: 4, name: "cure the Wastes" },
        { count: 1, name: "Barbie // Oppenheimer" },
        { count: 4, name: "Marsh Flats (Hellscube)" },
        { count: 13, name: "Plains" },
        { count: 4, name: "Harare" },
      ],
    },
  },

  {
    author: "Garf",
    title: "2024 Constructed Tournament - Top 8 - Food Food Food",
    text: "",
    cards: {
      sideboard: [
        { count: 4, name: "Shish Kebab" },
        { count: 4, name: "Tormod's MTV Crypts" },
        { count: 3, name: "Vilefin Inquisitor" },
        { count: 2, name: "Bread Weight" },
        { count: 2, name: "Whitewash" },
      ],
      main: [
        { count: 4, name: "Spatula" },
        { count: 4, name: "SpriteR Dragon" },
        { count: 4, name: "Swiss Army Mänufactör" },
        { count: 4, name: "Thraben Health Inspector" },
        { count: 4, name: "The Duck Song" },
        { count: 4, name: "Card Leak" },
        { count: 4, name: "Cloudy With a Chance of Meatballs" },
        { count: 4, name: "Pay You 100 To Fuck Off" },
        { count: 4, name: "Rampant Counterspell" },
        { count: 4, name: "Felidar Sanctuary" },
        { count: 4, name: "Forest" },
        { count: 4, name: "Garfield of the Dead" },
        { count: 4, name: "Nettle Field" },
        { count: 4, name: "Plains" },
        { count: 4, name: "Three Three City" },
      ],
    },
  },
  {
    author: "Fiish",
    title: "2024 Constructed Tournament - 9th - Naya Pride",
    text: "",
    cards: {
      sideboard: [
        { count: 3, name: "Tormod's MTV Crypts" },
        { count: 2, name: "Oakish Boarmasters" },
        { count: 4, name: "Wireless Snacker" },
        { count: 4, name: "Path Directly To Exile" },
        { count: 2, name: "nut Shot" },
      ],
      main: [
        { count: 4, name: "Ajani's Pride Mate" },
        { count: 4, name: "Addicted Gambler" },
        { count: 2, name: "Oakish Boarmasters" },
        { count: 4, name: "cure the Wastes" },
        { count: 4, name: "Bear Hate" },
        { count: 4, name: "Once Upon a Tithe" },
        { count: 4, name: "Path to the Gift Shop" },
        { count: 4, name: "Tax Audit" },
        { count: 3, name: "Bodystorm" },
        { count: 4, name: "Mountain Pass" },
        { count: 4, name: "There Is No Bias In Color Balance" },
        { count: 4, name: "Apple Trees" },
        { count: 2, name: '"Tranquil" Frontier' },
        { count: 2, name: "Children's Hospital" },
        { count: 4, name: "Evolving Fabled Terramorphic Vista" },
        { count: 1, name: "Plains" },
        { count: 1, name: "Forest" },
        { count: 1, name: "Mountain" },
        { count: 4, name: "Eladamri's Spam Call" },
      ],
    },
  },
  {
    author: "Flamingseahorse",
    title: "2024 Constructed Tournament - 10th - Monowhite Control",
    text: "",
    cards: {
      sideboard: [
        { count: 4, name: "Ransom Note" },
        { count: 4, name: "Tormod's MTV Crypts" },
        { count: 1, name: "Totally Just a Cantrip I Swear" },
        { count: 2, name: "Luxury Tax" },
        { count: 4, name: "Path Directly To Exile" },
      ],
      main: [
        { count: 4, name: "Knight of the Whiter Orchid" },
        { count: 1, name: "Mangara Condor" },
        { count: 2, name: "The Prismatic Piper (hc)" },
        { count: 4, name: "White Counterspell" },
        { count: 4, name: "whelming Splendor" },
        { count: 4, name: "Card Leak" },
        { count: 1, name: "Luxury Tax" },
        { count: 4, name: "Tax Audit" },
        { count: 4, name: "Barbie // Oppenheimer" },
        { count: 4, name: "Rerelease" },
        { count: 2, name: "Pay You 100 To Fuck Off" },
        { count: 4, name: "Permeating Pass" },
        { count: 22, name: "Plains" },
      ],
    },
  },
  {
    author: "sixel",
    title: "2024 Constructed Tournament - 11th - Goyf Stuff",
    text: "A fast and resiliant deck piloted by a terrible player.",
    cards: {
      sideboard: [
        { count: 3, name: "Grounter Spell" },
        { count: 4, name: "Thrashing // Entering" },
        { count: 4, name: "Rampant Counterspell" },
        { count: 4, name: "Bear in Mind" },
      ],
      main: [
        { count: 4, name: "Mob Farming Tower" },
        { count: 4, name: "Goyflebrand" },
        { count: 3, name: "Cathartic Cathar" },
        { count: 4, name: "Goyf's Best Friend" },
        { count: 2, name: "Elder Dragon Highland" },
        { count: 2, name: "Grovergrown Tomb" },
        { count: 2, name: "Groff Bayou" },
        { count: 4, name: "Dumpstergoyf" },
        { count: 4, name: "Very Motivated Skeleton" },
        { count: 4, name: "Web M.D." },
        { count: 2, name: "Mining" },
        { count: 3, name: "Assassin’s Participation Trophy" },
        { count: 2, name: "One with That Thing" },
        { count: 3, name: "SwAmp (Hellscube)" },
        { count: 4, name: "Jund Supermarket" },
        { count: 2, name: "Wasteland Oasis" },
        { count: 2, name: "The Haunted Mansion" },
        {
          count: 2,
          name: "Time-Worn Jund Deckbox // Time-Worn Bloodbraid Elf",
        },
        { count: 1, name: "Overgrown, Tomb of Yawgmoth" },
        { count: 2, name: "Compleated Mountain" },
        { count: 2, name: "Bo Mat, the Courier" },
        { count: 1, name: "Bad Nauseum" },
        { count: 1, name: "Card Draw Cruise" },
      ],
    },
  },
  {
    author: "Chai",
    title: "2024 Constructed Tournament - 12th - Autotog aggro",
    text: "",
    cards: {
      sideboard: [
        { count: 3, name: "Tormod's MTV Crypts" },
        { count: 4, name: "Snarkbound Ravager" },
        { count: 4, name: "Flummox" },
        { count: 4, name: "Precognitive Bolt" },
      ],
      main: [
        { count: 4, name: "Autotog" },
        { count: 4, name: "Mox Charger" },
        { count: 2, name: "Breeches" },
        { count: 4, name: "Wind-Up Toy(ga)" },
        { count: 4, name: "Fishbowl Inquisitor" },
        { count: 4, name: "Mechanical Rootwalla" },
        { count: 4, name: "Memnite // Wastes" },
        { count: 4, name: "Darksteel Chad" },
        { count: 4, name: "Sheoldred, Whispering One (hc)" },
        { count: 4, name: "Avatar of Flexing" },
        { count: 4, name: "Thinking About Volleyballs" },
        { count: 4, name: "Three Three City" },
        { count: 3, name: "Creeping Car Pit" },
        { count: 3, name: "Crypto Mine" },
        { count: 4, name: "Marsh of Metallic Taste" },
        { count: 4, name: "Memnite with a Spark" },
      ],
    },
  },

  {
    author: "LegallyAbyssal",
    title: "2024 Constructed Tournament - 13th - Sideboard Purple",
    text: "",
    cards: {
      sideboard: [
        { count: 1, name: "Bear but Woah" },
        { count: 2, name: "Fblthp, Lost in Space" },
        { count: 4, name: "Ninja of the Deep Space" },
        { count: 2, name: "Spellcounter" },
        { count: 4, name: "Die by Pi" },
        { count: 2, name: "Mad Libs Removal" },
      ],
      main: [
        { count: 4, name: "Average Hells2 Fan // Average Hells1 Enjoyer" },
        { count: 4, name: "Crab Nebula" },
        { count: 2, name: "Build-A-Bear" },
        { count: 4, name: "Crazed Designer" },
        { count: 4, name: "Elvian Spirit Guide" },
        { count: 4, name: "Ragavan, But We Sent Him To Space" },
        { count: 4, name: "Sheoldred, Whispering One (hc)" },
        { count: 4, name: "Theoretical physicist Orc" },
        { count: 2, name: "Black Creature Removal" },
        { count: 4, name: "Haunted Moon" },
        { count: 4, name: "PP Extender" },
        { count: 4, name: "Swirly Twirly Blood Straw" },
        { count: 4, name: "Thriving Portal" },
        { count: 4, name: "Acquisition of Kozilek" },
        { count: 4, name: "In the Cage with Marit Lage" },
        { count: 4, name: "Inquisition of Haktos the Unscarred" },
      ],
    },
  },
  {
    author: "Leslie",
    title: "2024 Constructed Tournament - 14th - UW Control",
    text: "",
    cards: {
      sideboard: [
        { count: 3, name: "Gatekeeper" },
        { count: 2, name: "1/2 of Elesh Norn, Rounded Up" },
        { count: 4, name: "Whitewash" },
        { count: 3, name: "Pay You 100 To Fuck Off" },
        { count: 2, name: "Draw the Out // Be Consistent // Draw the Out" },
        { count: 1, name: "Guy Tefieri" },
      ],
      main: [
        { count: 4, name: "Wiimote" },
        { count: 3, name: "Marie Kondo" },
        { count: 2, name: "Vilefin Inquisitor" },
        { count: 2, name: "The Prismatic Piper (hc)" },
        { count: 4, name: "Flummox" },
        { count: 4, name: "Counterspell Balanced for EDH" },
        { count: 4, name: "enchant" },
        { count: 3, name: "You're Going // Brazil" },
        { count: 3, name: "TL;DR (hc3)" },
        { count: 2, name: "Crucifact or Crucifixion" },
        { count: 1, name: "Pay You 100 To Fuck Off" },
        { count: 4, name: "Polluted Δ" },
        { count: 4, name: "Evolving Fabled Terramorphic Vista" },
        { count: 4, name: "Plains" },
        { count: 3, name: "Island" },
        { count: 1, name: "The British Empire" },
        { count: 4, name: "Actual Tundra" },
        { count: 2, name: "Thirty-Six Chambers" },
        { count: 2, name: "Jace, Living Library" },
        { count: 4, name: "Hush" },
      ],
    },
  },
  {
    author: "colorsofthestorm",
    title: "2024 Constructed Tournament - 15th - Dump-Walla",
    text: "",
    cards: {
      main: [
        { count: 4, name: "Dumpstergoyf" },
        { count: 2, name: "Baskin Robwalla" },
        { count: 4, name: "Baskcaster Magewalla" },
        { count: 4, name: "Venting Rootwalla" },
        { count: 2, name: "Basking Tuatara" },
        { count: 4, name: "Blood ghast // Crip Ghast" },
        {
          count: 4,
          name: "I'm The Demon From Demon Fire And You're Watching The",
        },
        { count: 2, name: "Addicted Gambler" },
        { count: 4, name: "Eidolon of Insurance Fraud" },
        { count: 3, name: "Sponsored Expedite" },
        { count: 12, name: "Mountain" },
        { count: 4, name: "Thresh's Hole" },
        { count: 3, name: "Swamp" },
        { count: 4, name: "Get // The Point" },
        { count: 4, name: "Going // The Store" },
      ],
      sideboard: [
        { count: 3, name: "Ramunap Expediter" },
        { count: 2, name: "Addicted Gambler" },
        { count: 4, name: "Basked Rootwalla" },
        { count: 3, name: "Krenko's Remand" },
        { count: 3, name: "Out of Spell Slots" },
      ],
    },
  },

  {
    author: "klunkerpunker",
    title: "2024 Constructed Tournament - 16th - Jund Lands",
    text: "",
    cards: {
      sideboard: [
        { count: 2, name: "Bojuka Dog" },
        { count: 3, name: "Fair Removal Spell" },
        { count: 4, name: "Really Ancient Grudge" },
        { count: 2, name: "Dead on Arrival // Naturalize Magic" },
        { count: 2, name: "Inquisition of Haktos the Unscarred" },
        { count: 2, name: "Red Effects the Cube is Lacking in Charm" },
      ],
      main: [
        { count: 4, name: "Ramunap Expediter" },
        { count: 3, name: "THE CENTIPEDE" },
        {
          count: 2,
          name: "I'm The Demon From Demon Fire And You're Watching The",
        },
        { count: 4, name: "Speedrunner" },
        { count: 1, name: "Treefucker" },
        { count: 1, name: "Avenging Ooze" },
        { count: 4, name: "Mining" },
        { count: 2, name: "Assassin’s Participation Trophy" },
        { count: 3, name: "Grounter Spell" },
        { count: 4, name: "Wasteland Oasis" },
        { count: 2, name: "Swamp" },
        { count: 4, name: "Forest" },
        { count: 2, name: "Mountain" },
        { count: 3, name: "Stomped Ground" },
        { count: 4, name: "Squadron Wastes" },
        { count: 1, name: "Raugrin Welcome Mat" },
        { count: 4, name: "Overgrown, Tomb of Yawgmoth" },
        { count: 2, name: "Jund Supermarket" },
        { count: 3, name: "Cathartic Reunion But It's Dumb" },
        { count: 4, name: "Awoken Rotation" },
        { count: 2, name: "Inquisition of Haktos the Unscarred" },
        { count: 1, name: "Banefieri" },
      ],
    },
  },

  {
    author: "Red",
    title: "Deck Designed for Legend Designed for Commander",
    text: "An Esper deck that uses its commander as an efficient draw engine and supports it with a variety of ETB synergies.",
    cards: {
      sideboard: [],
      main: [
        { count: 1, name: "Legend Designed for Commander" },
        { count: 1, name: "It That Enters" },
        { count: 1, name: "Kozilek, Drawn From Memory" },
        { count: 1, name: "Eldrazi Misplacer" },
        { count: 1, name: "Archmage of the Photocopier" },
        { count: 1, name: "Out of Inkling" },
        { count: 1, name: "It That Juggles" },
        { count: 1, name: "Bojuka Dog" },
        { count: 1, name: "ENTER // EXIT" },
        { count: 1, name: "Errata, the Silencer" },
        { count: 1, name: "Gentleman" },
        { count: 1, name: "Wailord" },
        { count: 1, name: "Doom Crow" },
        { count: 1, name: "I’m an original thought haver!" },
        { count: 1, name: "Regal Karakas" },
        { count: 1, name: "Obelisk Dollar Store" },
        { count: 1, name: "Call the Dermotaxi!" },
        { count: 1, name: "Spirited Companharmonicon" },
        { count: 1, name: "Big Rock" },
        { count: 1, name: "WotC Spy" },
        { count: 1, name: "Galaxy Brain Ugin" },
        { count: 1, name: "It Goes On // On // On // On" },
        { count: 1, name: "Oops I dropped all my bones" },
        { count: 1, name: "Sword of Warren Instigator" },
        { count: 1, name: "Death // Death" },
        { count: 1, name: "Photocopier" },
        {
          count: 1,
          name: "Learn // Work // Play // Get Along With Each Other",
        },
        { count: 1, name: "Loot That Body" },
        { count: 1, name: "Nabanharmonicon" },
        { count: 1, name: "Myr in Misery" },
        { count: 1, name: "Flicker into Oblivion" },
        { count: 1, name: "Emergency Wipe" },
        { count: 1, name: "My Ex's Reign of Lies // Portrait of My Ex" },
        { count: 1, name: "Isle of Man" },
        { count: 1, name: "Archetype of ()" },
        { count: 1, name: "🐟'RE ESC🐟" },
        { count: 1, name: "Magus of the Mox Pearl" },
        { count: 1, name: "Isamaru // Wasamaru" },
        { count: 1, name: "DiMyr Signet" },
        { count: 1, name: "The Thinker" },
        { count: 1, name: "Rapheap Scrounger" },
        { count: 1, name: "Breeding Pool a literal one" },
        { count: 1, name: "Rerelease" },
        { count: 1, name: "F*ckerwisp" },
        { count: 1, name: "Wrath of Salt" },
        { count: 1, name: "HC6: Banish to Minimum Wage" },
        { count: 1, name: "Luchador" },
        { count: 1, name: "Depression" },
        { count: 1, name: "Spell Slang" },
        { count: 1, name: "Skitter of Wizards" },
        { count: 1, name: "Command Phyrexian Tower" },
        { count: 1, name: "Convolving Wilds" },
        { count: 1, name: "Discount Mox Box" },
        { count: 1, name: "Weezer Signet" },
        { count: 1, name: "Mana Pride Shirt" },
        { count: 1, name: "ClueTM Game Board" },
        { count: 1, name: "!Macro Own" },
        { count: 1, name: "Convergent Evolution" },
        { count: 1, name: "Engineered Explosive Vegetation" },
        { count: 1, name: "Cursed Sliver Burial Ground" },
        { count: 1, name: "Zoning Violation" },
        { count: 1, name: "Evil Fucking Wizard Spell" },
        { count: 1, name: "Unnecessary Side Quest" },
        { count: 1, name: "Elkster's Trick" },
        { count: 1, name: "Inclusive Golem" },
        { count: 1, name: "Flummox" },
        { count: 1, name: "Minions: The Rise of Gru" },
        {
          count: 1,
          name: "ah my toaster has suffered a traumatic experience and has planeswalked to theros. // Toaster, on Theros",
        },
        { count: 1, name: "Tinybones' Wild Ride" },
        { count: 1, name: "Shitting With Not Blood Involved" },
        { count: 1, name: "Coastal Bluffs" },
        { count: 9, name: "Swamp" },
        { count: 9, name: "Plains" },
        { count: 11, name: "Island" },
      ],
    },
  },
  {
    title: "Goyf Control",
    text: `Arguably, Goyf Control is a deck. A collection of cards. It utilizes Pious Gravegoyf for beats and has a highly removal-based gameplan.
    
    Look at this paragraph break weee`,
    author: "i forgot",
    cards: {
      main: [
        { name: "Jund Supermarket", count: 4 },
        { name: "Pious Gravegoyf", count: 4 },
        { name: "Amogis, God of Sus", count: 2 },
        { name: "Dead on Arrival // Naturalize Magic", count: 4 },
        { name: "Rootin Tootin Tutor", count: 4 },
        { name: "Thrashing // Entering", count: 2 },
        { name: "Evolving Fabled Terramorphic Vista", count: 4 },
        { name: "Overgrown, Tomb of Yawgmoth", count: 1 },
        { name: "Forest", count: 2 },
        { name: "Mountain", count: 2 },
        { name: "Swamp", count: 1 },
        { name: `Thresh's hole`, count: 1 },
        { name: "Wasteland Oasis", count: 4 },
        { name: "Altar of Broken Mechanics", count: 4 },
        { name: "Spooky Brainstorm", count: 4 },
        { name: "ThoughtSeas", count: 4 },
        { name: "Look For Trouble", count: 4 },
        { name: "Miasma // My Asthma", count: 4 },
        { name: "Cathartic Reunion But It's Dumb", count: 4 },
      ],
      sideboard: [
        {
          name: "Turn to Nature",
          count: 4,
        },
        {
          name: "Wolf Within",
          count: 4,
        },
        {
          name: "Spellcounter",
          count: 3,
        },
        {
          name: "Reject You Reality // Substitute My Own",
          count: 4,
        },
      ],
    },
  },
  {
    title: "UW Moderator",
    text: `Moderator seems to be the boogyman of the format. It plus a few counterspells is capable of locking out a good number of non-agro decks.`,
    author: "Glassbass",
    cards: {
      main: [
        { name: "Moderator", count: 4 },
        { name: "Thraben Rejector", count: 4 },
        { name: "Postmodernism", count: 4 },
        { name: "Shark", count: 3 },
        { name: "Flummox", count: 4 },
        { name: "Crucifact or Crucifixion", count: 4 },
        { name: "Mana Auction", count: 4 },
        { name: "Tax Audit", count: 4 },
        { name: "Walmart", count: 4 },
        { name: "Actual Tundra", count: 4 },
        { name: "Island GX", count: 1 },
        { name: `Polluted Δ`, count: 1 },
        { name: "Island", count: 8 },
        { name: "Plains", count: 4 },
        { name: "Island", count: 4 },
      ],
      sideboard: [
        {
          name: "The Prismatic Piper (hc)",
          count: 2,
        },
        {
          name: "Adventure",
          count: 4,
        },
        {
          name: "Counter-Fucking-Spell",
          count: 4,
        },
        {
          name: "The Scary Door",
          count: 3,
        },
        {
          name: "Divine Gambit but It's Fucking Stupid",
          count: 4,
        },
      ],
    },
  },
  {
    title: "Pieramid break",
    text: `This is a controlling deck that uses Pyramid Schemer's extort counters and Color Pie Break by tacking "drain one, tutor a basic land" onto every spell. That combined with cheap spells help allow for huge Dracjack turns.`,
    author: "Glassbass",
    cards: {
      main: [
        { name: "Pyramid Schemer", count: 4 },
        { name: "Sheoldred, Whispering One (hc)", count: 4 },
        { name: "Color Pie Break", count: 3 },
        { name: "White Counterspell", count: 4 },
        { name: "Stigmatize", count: 4 },
        { name: "whelming Splendor", count: 3 },
        { name: "Dracjack", count: 4 },
        { name: "Evolving Fabled Terramorphic Vista", count: 3 },
        { name: "Swamp", count: 6 },
        { name: "Plains", count: 9 },
        { name: "Moor of That Strange Oil", count: 2 },
        { name: "Snarlsnarlsnarl", count: 4 },
        { name: "Inquisition of Haktos the Unscarred", count: 4 },
        { name: "Dis Enchant", count: 4 },
      ],
      sideboard: [
        {
          name: "The Prismatic Piper (hc)",
          count: 2,
        },
        {
          name: "Abrupt Silence",
          count: 3,
        },
        {
          name: "Card Leak",
          count: 4,
        },
        {
          name: "Miasma // My Asthma",
          count: 4,
        },
        {
          name: "The Scary Door",
          count: 4,
        },
      ],
    },
  },
  {
    title: "Bant Moderator Tempo",
    text: `oh god more mod`,
    author: "Requiem",
    cards: {
      main: [
        { name: "Elephant Jump Scare", count: 4 },
        { name: "Moderator", count: 4 },
        { name: "Postmodernism", count: 4 },
        { name: "Thraben Rejector", count: 4 },
        { name: "Hush", count: 4 },
        { name: "Crucifact or Crucifixion", count: 4 },
        { name: "Into the Royal", count: 4 },
        { name: "Mana Auction", count: 4 },
        { name: "Tax Audit", count: 2 },
        { name: "Swamp (hc)", count: 4 },
        { name: "There Is No Bias In Color Balance", count: 4 },
        { name: "Tranquil Frontier", count: 2 },
        { name: "Tropical", count: 4 },
        { name: "Walmart", count: 4 },
        { name: "dRafter Demon's Used Car Lot", count: 4 },
        { name: "Ginkhole", count: 4 },
      ],
      sideboard: [
        {
          name: "Escalation Sage",
          count: 2,
        },
        {
          name: "Pithing Beeble",
          count: 2,
        },
        {
          name: "Scapegoat (HC3)",
          count: 1,
        },
        {
          name: "Stigmatize",
          count: 2,
        },
        {
          name: "Get Out of Jail Free",
          count: 4,
        },
        {
          name: "Tax Audit",
          count: 2,
        },
        {
          name: "Zoning Violation",
          count: 2,
        },
      ],
    },
  },
];
